import type { ReleaseNoteType } from '@/types/releaseNotes';

const ukDate = (iso: string, options: Intl.DateTimeFormatOptions) =>
  new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', ...options }).format(new Date(iso));

/** "Week ending 16 October 2026" for a weekly edition, "April 2026" for a monthly one. Matches the Slack messages. */
export function periodLabel(edition: { kind: 'weekly' | 'backfill'; period: { from: string; to: string } }) {
  return edition.kind === 'backfill'
    ? ukDate(edition.period.from, { month: 'long', year: 'numeric' })
    : `Week ending ${ukDate(edition.period.to, { day: 'numeric', month: 'long', year: 'numeric' })}`;
}

export const publishedLabel = (iso: string) => ukDate(iso, { day: 'numeric', month: 'long', year: 'numeric' });

export const publishTimeLabel = (iso: string) =>
  ukDate(iso, { weekday: 'short', day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });

export const TYPE_LABELS: Record<ReleaseNoteType, string> = { new: 'New', improved: 'Improved', fixed: 'Fixed' };

export const changeCount = (n: number) => `${n} change${n === 1 ? '' : 's'}`;
